import numeral from 'numeral';
import CurrencyHelper from './CurrencyHelper';

export function currency(value = 0, symbol = false, skipDecimal = false) {
  let negative = value < 0;
  let val = skipDecimal ? numeral(Math.abs(value)).format('0,0') : numeral(Math.abs(value)).format('0,0.[0]]');

  let returnValue = val;
  let absValue = Math.abs(value);

  if(!value % 1 == 0) {
    returnValue = parseFloat(Math.round(absValue * 100) / 100).toFixed(2);
  } else {

  }

  if(value % 1 == 0) {
    returnValue = parseInt(absValue, 10);
  }

  returnValue = skipDecimal ? numeral(Math.abs(returnValue)).format('0,0') : numeral(Math.abs(returnValue)).format('0,0[.]00');

  if(symbol) {
    if(symbol === true) {
      returnValue = CurrencyHelper.getCurrencySymbol() + returnValue;
    } else {
      returnValue = CurrencyHelper.getCurrencySymbol(symbol) + returnValue;
    }
  }

  if(negative) {
    returnValue = '-' + returnValue;
  }

  return returnValue;
}


export default {
  currency
}



// WEBPACK FOOTER //
// ./src/logic/util/NumberHelper.js